import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export const useAnalytics = () => {
  const { user } = useAuth();

  const trackEvent = useCallback(async (
    eventType: string,
    eventData?: Record<string, any>,
    pagePath?: string
  ) => {
    if (!user) return;

    try {
      await supabase.from('user_analytics').insert({
        user_id: user.id,
        event_type: eventType,
        event_data: eventData || {},
        page_path: pagePath || window.location.pathname,
      });
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  }, [user]);

  return { trackEvent };
};
